import React from "react";
import { useLocation, Link } from "react-router-dom";
import SEO from "./SEO";

const ThankYou = () => {
  const location = useLocation();
  const orderId = location.state?.orderId;

  return (
    <>
      <SEO
        title='Thank You'
        description='Blank Beanies'
        keywords='Blank Beanies'
      />
      <div className="text-center py-20">
        <h1 className="text-4xl font-bold text-green-600">
          Thank You for Your Order!
        </h1>

        {orderId && (
          <p className="text-xl mt-4">
            Your Order ID is: <strong>{orderId}</strong>
          </p>
        )}

        <Link
          to="/"
          className="mt-10 inline-block bg-black text-white px-6 py-3 rounded-lg"
        >
          Continue Shopping
        </Link>
      </div>
    </>
  );
};

export default ThankYou;
